"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnLabel = columnLabel;
exports.columns = columns;
exports.cell = cell;
exports.header = header;
exports.cellValue = cellValue;
exports.toRows = toRows;
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
const ProductProperties = __importStar(require("@genesys/shared/lib/product-properties"));
const QuantityConversion = __importStar(require("@genesys/shared/lib/quantity-conversion"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const functions_1 = require("./functions");
function columnLabel(propertyName, translate) {
    return translate(LanguageTexts.globalPropertyName("coilprotool_results_" + propertyName));
}
/**
 * Outlet humidity is the one column that can be shown in a quantity other than the one it
 * arrives in, and converting it needs the air state it belongs to - which is per case.
 */
function conversionFor(propertyName, result) {
    return propertyName === "humidityout"
        ? (0, functions_1.conversionParametersFor)(result)
        : undefined;
}
function columns(
// The screen passes its result definitions and the download picker the columns that are
// ticked, so only the name is asked for.
definitions, results, formats, translate) {
    // The first case decides the units the whole column is shown in; they all hold the same
    // quantity, so any of them would give the same answer.
    const first = results.length > 0 ? results[0].result : property_1.PropertyValueSet.Empty;
    return definitions.map(definition => {
        const name = definition.propertyName;
        const value = property_1.PropertyValueSet.get(name, first);
        const format = formats[name];
        if (!value || value.type !== "amount") {
            return {
                propertyName: name,
                label: columnLabel(name, translate),
                unit: "",
                selectedUnit: undefined,
                selectedDecimalCount: undefined,
                userSelected: false,
                type: value && value.type
            };
        }
        const { selectedUnit, selectedDecimalCount } = ProductProperties.getFormat(format, property_1.PropertyValue.getAmount(value));
        const unitFormat = uom_1.Format.getUnitFormat(selectedUnit, uom_1.UnitsFormat);
        return {
            propertyName: name,
            label: columnLabel(name, translate),
            unit: (unitFormat && unitFormat.label) || "",
            selectedUnit,
            selectedDecimalCount,
            userSelected: (format && format.userDefined) || false,
            type: value.type
        };
    });
}
/** One cell as the screen shows it: the value rounded to the decimals its column is set to. */
function cell(propertyName, result, formats) {
    const value = property_1.PropertyValueSet.get(propertyName, result);
    if (!value) {
        return "";
    }
    return ProductProperties.getValue(value, formats[propertyName], conversionFor(propertyName, result));
}
/** A column's heading: its name, with the unit it is shown in alongside. */
function header(column) {
    return column.unit ? `${column.label} (${column.unit})` : column.label;
}
/**
 * The same value as `cell`, but as a number where it is one, in the unit its column is shown
 * in. A workbook takes its cell types from these, so a result arrives as something that can be
 * summed and charted rather than as text that has to be converted first - and a number carries
 * its own precision, which is why the sheet does not round the way the screen does.
 */
function cellValue(propertyName, result, formats) {
    const value = property_1.PropertyValueSet.get(propertyName, result);
    if (!value) {
        return "";
    }
    if (value.type !== "amount") {
        return cell(propertyName, result, formats);
    }
    const amount = property_1.PropertyValue.getAmount(value);
    const { selectedUnit } = ProductProperties.getFormat(formats[propertyName], amount);
    const conversion = conversionFor(propertyName, result);
    if (selectedUnit.quantity !== amount.unit.quantity) {
        if (!conversion) {
            // Same answer the formatter gives, so the sheet says what the screen says.
            return cell(propertyName, result, formats);
        }
        return uom_1.Amount.valueAs(selectedUnit, QuantityConversion.convertQuantity(amount, selectedUnit.quantity, conversion));
    }
    return uom_1.Amount.valueAs(selectedUnit, amount);
}
/** The whole table - what the downloaded workbook holds. */
function toRows(columnsToShow, results, formats) {
    return [
        columnsToShow.map(header),
        ...results.map(r => columnsToShow.map(c => cellValue(c.propertyName, r.result, formats)))
    ];
}
//# sourceMappingURL=result-table.js.map